import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSession } from './session'
import { isStaffRole } from './types'

interface GuardProps {
  children: ReactNode
}

function Loading(): ReactNode {
  return (
    <div className="flex min-h-screen items-center justify-center text-muted-foreground">
      Cargando...
    </div>
  )
}

/**
 * Permite el acceso a cualquier miembro del staff (ADMIN o DOCENTE). Se aplica
 * al subarbol del dashboard para que los docentes puedan entrar. Cada seccion
 * exclusiva de ADMIN se gatea con `RequireAdmin`. Ver specs/docente-fichas.md.
 */
export function RequireStaff({ children }: GuardProps): ReactNode {
  const { status, user } = useSession()
  const location = useLocation()

  if (status === 'loading') return <Loading />

  if (status !== 'authenticated' || !user || !isStaffRole(user.rol)) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <>{children}</>
}

/** Solo ADMIN. Secciones de Noticias, Usuarios y Docentes. */
export function RequireAdmin({ children }: GuardProps): ReactNode {
  const { status, user } = useSession()
  const location = useLocation()

  if (status === 'loading') return <Loading />

  if (status !== 'authenticated' || !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  // Un docente autenticado que intenta abrir una seccion de admin se redirige
  // a su unica seccion permitida.
  if (user.rol !== 'ADMIN') {
    return <Navigate to="/dashboard/fichas" replace />
  }

  return <>{children}</>
}
